import { render, staticRenderFns } from "./BaseSelectBox.vue?vue&type=template&id=2b94bff6&scoped=true"
import script from "./BaseSelectBox.vue?vue&type=script&lang=js"
export * from "./BaseSelectBox.vue?vue&type=script&lang=js"
import style0 from "./BaseSelectBox.vue?vue&type=style&index=0&id=2b94bff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b94bff6",
  null
  
)

export default component.exports